// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  ReportLoaderDisplay,
  depreciationScheduleReportConfig,
  useReportLoaderProgress,
} from '@/report/components/report-loader';

interface Props {
  isDataReady?: boolean;
  onComplete?: () => void;
  periodCount: number;
}

export function DepreciationScheduleReportLoader(props: Props) {
  // Depreciation schedule reports compute values across each period, so timing
  // scales with periodCount (asset count x period count).
  const progress = useReportLoaderProgress({
    config: depreciationScheduleReportConfig,
    isDataReady: props.isDataReady,
    onComplete: props.onComplete,
    periodCount: props.periodCount,
    useAssetPeriods: true,
  });

  return (
    <ReportLoaderDisplay
      currentStep={progress.currentStep}
      completedSteps={progress.completedSteps}
      stepLabels={depreciationScheduleReportConfig.stepLabels}
    />
  );
}
